import React, { useEffect, useState } from 'react'
import styles from './Projects.module.css'
import { HoverState } from '../../../assets/utils/cursorTypes'
import BoxProject from './BoxProject/BoxProject'
import { sanityClient } from '../../../assets/lib/sanity.client'
import { ProjectInterface } from '../../../assets/lib/types/project'
import { useLocation } from 'react-router-dom'

export type ProjectsProps = {
    setHoverElement: React.Dispatch<React.SetStateAction<HoverState>>;
}

const Projects = (props: ProjectsProps) => {

    const [project, setProject] = useState<ProjectInterface[]>([]);
    const location = useLocation();

    useEffect(() => {
        const query = `*[_type == "project"]{
                        ...
                    }`;

        (sanityClient as any).fetch(query)
            .then((data : ProjectInterface[]) => {
                setProject(data)
            })
            .catch((error: any) => {
                console.log(error);
            })
    }, [location]);


    return (
        <div className={styles.container}>
            {project.map((item, index) => (
                <BoxProject
                    key={index}
                    setHoverElement={props.setHoverElement}
                    project={item}
                />
            ))}
        </div>
    )
}

export default Projects
